var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserHdi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.5,
    height: 32.5,
    viewBox: "0 0 32.5 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M13.968,17.914a5.968,5.968,0,0,0-11.937,0H0a8,8,0,0,1,16,0ZM3.407,4.58A4.593,4.593,0,1,1,8,9.158,4.592,4.592,0,0,1,3.407,4.58Zm2.034,0A2.56,2.56,0,1,0,8,2.026,2.558,2.558,0,0,0,5.441,4.58Z",
    fill: "#006729"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17991",
    "data-name": "Grupo 17991",
    transform: "translate(49.25 -4.206)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-49 4.456)",
    fill: "#fff",
    stroke: "#65a518",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_User",
    "data-name": "Icon/User",
    transform: "translate(-41 11.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M13.968,17.914a5.968,5.968,0,0,0-11.937,0H0a8,8,0,0,1,16,0ZM3.407,4.58A4.593,4.593,0,1,1,8,9.158,4.592,4.592,0,0,1,3.407,4.58Zm2.034,0A2.56,2.56,0,1,0,8,2.026,2.558,2.558,0,0,0,5.441,4.58Z",
    fill: "#006729"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-2",
    "data-name": "Color/Liberty Blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-3",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-55.386 -55.233)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy",
    "data-name": "Rectangle Copy",
    width: 124.312,
    height: 119.058,
    fill: "#006729"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHdi);
export default __webpack_public_path__ + "static/media/userHDI.3a78380bc8d2883486676a4cf18b3132.svg";
export { ForwardRef as ReactComponent };